import angular from 'angular';
import syncOrderModal from '../sync-order-modal/sync-order-modal.view.html';
import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalDriver from '../../shared/components/modal-driver/modal-driver.view.html';

let inject = [
    '$scope',
    'OrderDetailService',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    'Pagination',
    'SessionService',
    '$window',
    'ngAuthSettings',
    '$stateParams',
    'OrdersService'
];

class OrderDetailController {
    constructor($scope,
                OrderDetailService,
                $state,
                $rootScope,
                SharedService,
                $uibModal,
                $timeout,
                Pagination,
                SessionService,
                $window,
                ngAuthSettings,
                $stateParams,
                OrdersService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ngAuthSettings = ngAuthSettings;
        this.$uibModal = $uibModal;
        this.OrderDetailService = OrderDetailService;
        this.Pagination = Pagination;
        this.SharedService = SharedService;
        this.loadingDataOrder = true;
        this.SessionService = SessionService;
        this.$window = $window;
        this.messageNotification = '';
        this.titleMessageNotification = '';
        this.orderId = this.$stateParams.orderId;
        this.orderData = {};
        this.orderLogo = "./assets/img/clients/" + __env.clientName + "/logo-header.png";
        this.sellerComment = false;
        this.sellerCommentText = null;
        this.OrdersService = OrdersService;
    }

    $onInit() {
        this.getOrder(this.orderId);
    }

    changeStatus() {
        let globals = this.shCtrl.globals;
        let sellerId = '';

        try {
            sellerId = globals.currentUser.sellerId;
        }
        catch (e) {
        }
        this.orderSaved = false;
        this.OrderDetailService.changeStatus({
            'id': this.orderData.id,
            'sellerId': sellerId,
            'estado': this.orderData.estado_documento_id
        }).then(response => {
            this.orderSaved = true;
        }).catch(reason => {
            this.orderSaved = true;
        });
    }

    getOrder(orderId) {


        let globals = this.shCtrl.globals;
        let userId = '';
        try {
            userId = globals.currentUser.userId;
        }
        catch (e) {
        }
        let sellerId = '';
        try {
            sellerId = globals.currentUser.sellerId;
        }
        catch (e) {
        }

        // Send the request
        this.OrderDetailService.getOrderById({
            'orderId': orderId,
            'typeOrders': '',
            'userId': userId,
            'sellerId': sellerId,
            'cartId': this.SessionService.get('cartId') || '' 
        }).then(response => {
            this.loadingDataOrder = false;
            if (!response.error) {
                this.orderData = response.data.order;
                this.orderData.totalPesoItems = this.orderData.totalPesoItems?this.orderData.totalPesoItems:0;
                this.orderData.cantidadTotalCanasta = 0;
                response.data.order.items.forEach(val => {
                    if(!this.orderData.totalPesoItems || this.orderData.totalPesoItems == 0 || this.orderData.totalPesoItems == "" || angular.isUndefined(this.orderData.totalPesoItems)){
                      this.orderData.totalPesoItems += val.cantidad * val.peso_embalaje;
                    }

                    this.orderData.cantidadTotalCanasta += val.cantidad;
                });
            }
        }).catch(reason => {
            this.loadingDataOrder = false;
            alert('Ha ocurrido un error al obtener los datos');
        });
    }

    showModalDriver() {
        let options = {
            vehiculo_transporte: this.orderData.vehiculo_transporte
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalDriver,
            controller: 'ModalDriverController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {

        }).catch(reason => {

        });
    }

    syncOrder(orderId, orderData) {
        let options = {
            orderId
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: syncOrderModal,
            controller: 'SyncOrderModalController',
            controllerAs: 'mdCtrl',
            size: '',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(result => {

        }).catch(reason => {

        });
    }

    payNow(orderId) {

        let userId = '';
        try {
            userId = globals.currentUser.userId;
        } catch (e) {}

        if(this.orderData.estado_pago == "Procesando pago"){

            let options = {
                title: '',
                isHtml: true,
                content: "Lo sentimos! El pago de tu pedido está siendo procesado. Por favor intentalo de nuevo más tarde.",
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Cerrar'
            };
            this.messageResponse(options);
            return
        }

        this.OrdersService.recalculateOrder(orderId, userId).then(response => {
            if(!response.error){
                this.$window.location = window.__env.envApiServiceBaseUri + '/order/pay-gate?id=' + orderId;
            }else{

                if(this.orderData.estado_pago && response.data){
                    this.orderData.estado_pago = response.data;
                    this.orderData.showPayOrderAction = false;
                }

                let options = {
                    title: '',
                    isHtml: true,
                    content: response.message,
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            }
        });
        //this.$window.location = this.shCtrl.ngAuthSettings.config.env.apiEndPoint + '/order/pay-gate?id=' + orderId;
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    addCommentary() {
        this.sellerComment = true;
    }

    saveComment() {

        this.OrderDetailService.saveSaveComment({
            'coment': this.sellerCommentText,
            'orderId': this.orderId
        }).then(response => {
            if (!response.error) {
                this.orderData.anotaciones_vendedor = response.order.anotaciones_vendedor;
                this.sellerComment = false;
                this.sellerCommentText = null;
            }
        });


    }
    duplicateOrder() {
    this.loadingDuplicateOrders = true;
    let userId = '', sellerId = '';
    userId = this.shCtrl.globals.currentUser.userId;
    try {
      sellerId = this.shCtrl.globals.currentUser.sellerId;
    }
    catch (e) {
    }
    this.OrdersService.duplicateOrderById(userId, sellerId, this.orderData.id).then(response => {
      this.loadingDuplicateOrders = false;
      if (!response.error) {
        this.SessionService.put('cartId', response.cartId);
        this.$state.go('home.cart');
      }
      else {
        alert('No se pudo completar la acción.');
      }
    });
  }

    cancelComment() {
        this.sellerComment = false;
    }


}

OrderDetailController.$inject = inject;

export default OrderDetailController;




/** WEBPACK FOOTER **
 ** ./www/components/orders/order-detail/order-detail.controller.js
 **/